module.exports = __webpack_public_path__ + "static/media/radar.12e3c976.png";